/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Text, 1 = Number, 2 = Boolean, 3 = Choice
 */
export enum StationCommandParameterType {
    Text = 0,
    Number = 1,
    Boolean = 2,
    Choice = 3
}

